import { TERMINAL_MAC_OS_LINKS } from '@/core/constants';
import clsx from 'clsx';
import { TFunction, useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { FC, useState } from 'react';
import style from './style.module.scss';

const DROPDOWN_LIST_DATA_EN = (t: TFunction) => [
  {
    id: 1,
    title: 'What is tiger.com?',
    text: (
      <>
        Since 2015, tiger.com has been developing fintech products for traders of all levels: from
        experienced high-volume professionals to regular users. Our solutions are developed by an
        international team of fintech enthusiasts.
        <ul className={style.topOffset}>
          Our products are:
          <li>
            <a href="https://www.tiger.trade/terminal" className={style.link}>
              Tiger.com for Windows
            </a>
            &nbsp; — a desktop platform that enables users to trade on financial and cryptocurrency
            markets.
          </li>
          <li>
            <a href={TERMINAL_MAC_OS_LINKS.en} className={style.link}>
              Tiger.com macOS
            </a>{' '}
            — our desktop platform for macOS
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    title: 'What is trading platform?',
    text: (
      <>
        Tiger.com trading platform is a customizable desktop workspace for trading stocks, futures,
        cryptocurrencies, and Forex assets. The platform offers an exhaustive range of tools to
        satisfy the needs of beginners, advanced traders, and professionals alike. Tiger.com
        Platform features:
        <ul className={style.topOffset}>
          <li>stock, futures, options, cryptocurrency, and Forex asset trading</li>
          <li>demo trading on live and historical data</li>
          <li>built-in risk management system</li>
          <li>
            multifunctional charts, including clusters, Renko and volume bars, including various
            indicators
          </li>
          <li>DOM with extensive features for active trading.</li>
        </ul>
        <div>Using the platform, users can connect to:</div>
        <ul className={style.topOffset}>
          <li>
            different cryptocurrency and stock exchanges, including NYSE, NASDAQ, MOEX, SPBEX,
            Binance, OKX, and ByBit,
          </li>
          <li>
            trading terminals: SMARTcom, QUIK, MetaTrader 5, Rithmic, TRANSAQ, and GAIN Capital
            (OEC).
          </li>
        </ul>
        Tiger.com is currently available for&nbsp;
        <a href="https://www.tiger.trade/terminal" className={style.link}>
          Microsoft Windows.
        </a>
        &nbsp;and&nbsp;
        <a href={TERMINAL_MAC_OS_LINKS.en} className={style.link}>
          macOS
        </a>
        .
      </>
    ),
  },
  {
    id: 4,
    title: 'Are tiger.com products free to use?',
    text: (
      <>
        <a href="https://www.tiger.trade/terminal" className={style.link}>
          Tiger.com trading platform
        </a>
        &nbsp; is free to download and comes with an unlimited free Crypto license. You can trade
        cryptocurrency assets on top global cryptocurrency exchanges completely free of charge.
        <div className={style.topOffset}>
          If you’re interested in other types of assets, such as stocks, futures, options and Forex
          market, you’ll need to purchase the Full license. You’ll be pleased to learn that
          Tiger.com is one of the most affordable professional trading platforms on the market.
          Learn more about&nbsp;
          <a href="https://www.tiger.trade/terminal/prices" className={style.link}>
            our Pricing.
          </a>
        </div>
      </>
    ),
  },
  {
    id: 5,
    title: 'How to download tiger.com products?',
    text: (
      <>
        <ul>
          <li>
            To download <mark>Tiger.com</mark> trading platform for Windows,&nbsp;
            <a href="https://www.tiger.trade/terminal/download" className={style.linkSecondary}>
              follow this link
            </a>
            .
          </li>
          <li>
            To download <mark>Tiger.com for macOS</mark>,&nbsp;
            <a href={TERMINAL_MAC_OS_LINKS.en} target="_blank" className={style.linkSecondary}>
              follow this link
            </a>
            .
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 6,
    title: 'Which assets can you trade with tiger.com?',
    text: (
      <ul>
        <li>
          <a href="https://www.tiger.trade/terminal" className={style.link}>
            Tiger.com Platform for Windows
          </a>
          &nbsp; provides traders with access to multiple types of assets within a single workspace.
          Users can buy and sell stocks, futures, options, cryptocurrencies and trade on Forex.
        </li>
        <li>
          <a href={TERMINAL_MAC_OS_LINKS.en} className={style.link}>
            Tiger.com for macOS
          </a>
          &nbsp; allows users to trade cryptocurrencies on popular exchanges.
        </li>
      </ul>
    ),
  },
];

const DROPDOWN_LIST_DATA_RU = (t: TFunction) => [
  {
    id: 1,
    title: 'Что такое tiger.com?',
    text: (
      <>
        С 2015 года tiger.com разрабатывает продукты для трейдеров любого уровня: от начинающих
        пользователей до профессионалов. Над всеми продуктами работает международная команда из
        разных точек мира.
        <ul className={style.topOffset}>
          Наши продукты:
          <li>
            <a href="https://www.tiger.trade/ru/terminal" className={style.link}>
              Tiger.com Platform для Windows
            </a>
            &nbsp; — платформа для трейдинга на фондовых рынках и криптовалютных биржах.
          </li>
          <li>
            <a href={TERMINAL_MAC_OS_LINKS.ru} className={style.link}>
              Tiger.com macOS
            </a>{' '}
            — торговая платформа для macOS
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    title: 'Что такое торговая платформа?',
    text: (
      <>
        Tiger.com Platform — это торгово-аналитическая платформа, объединяющая все необходимые
        инструменты для успешного трейдинга. Платформа включает:
        <ul>
          <li>
            торговлю акциями, фьючерсами, опционами, криптовалютами и инструментами рынка Forex,
          </li>
          <li>торговлю в режиме «Демо» на исторических и реальных данных,</li>
          <li>встроенный в терминал риск-менеджер,</li>
          <li>
            многофункциональные графики, включая кластеры, ренко и объемные бары, а также множество
            индикаторов,
          </li>
          <li>стакан цен с обширным функционалом для активного трейдинга.</li>
        </ul>
        <div>На платформе можно подключаться к:</div>
        <ul>
          <li>
            различным криптовалютным и фондовым биржам, включая NYSE, NASDAQ, MOEX, SPBEX, Binance,
            OKX и ByBit,
          </li>
          <li>
            торговым терминалам: SMARTcom, QUIK, MetaTrader 5, Rithmic, TRANSAQ и GAIN Capital
            (OEC).
          </li>
        </ul>
        Платформа Tiger.com доступна для&nbsp;
        <a href="https://www.tiger.trade/ru/terminal" className={style.link}>
          Windows
        </a>
        &nbsp;и&nbsp;
        <a href={TERMINAL_MAC_OS_LINKS.ru} className={style.link}>
          macOS
        </a>
        .
      </>
    ),
  },
  {
    id: 4,
    title: 'Сколько стоят продукты tiger.com?',
    text: (
      <>
        Это зависит от конкретного инструмента и продукта:
        <ul className={style.topOffset}>
          <li>
            У&nbsp;
            <a href="https://www.tiger.trade/ru/terminal" className={style.link}>
              платформы Tiger.com
            </a>
            &nbsp; есть несколько видов лицензий. Всем пользователям доступна полностью бесплатная
            Криптолицензия для торговли на криптобиржах. Если вас интересует торговля акциями,
            фьючерсами, опционами и инструментами рынка Forex, для этого есть Полная лицензия. Для
            тестирования стратегий есть лицензия History Player. Все лицензии можно посмотреть в
            разделе с ценами.
            <a href="https://www.tiger.trade/ru/terminal/prices" className={style.link} />
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 5,
    title: 'Как скачать продукты tiger.com?',
    text: (
      <>
        Способ загрузки зависит от нужного вам продукта:
        <ul className={style.topOffset}>
          <li>
            Скачать платформу <mark>Tiger.com</mark> для Windows можно&nbsp;
            <a href="https://www.tiger.trade/ru/terminal" className={style.linkSecondary}>
              по ссылке
            </a>
            .
          </li>
          <li>
            Скачать <mark>Терминал для macOS</mark> можно&nbsp;
            <a href={TERMINAL_MAC_OS_LINKS.ru} className={style.linkSecondary}>
              по ссылке
            </a>
            .
          </li>
          <div className={style.topOffset}>
            Мы не рекомендуем скачивать наши инструменты на сторонних сайтах, поскольку в этом
            случае не можем гарантировать безопасность скаченного ПО.
          </div>
        </ul>
      </>
    ),
  },
  {
    id: 6,
    title: 'С какими активами можно работать через tiger.com?',
    text: (
      <>
        Это зависит от выбранного продукта:
        <ul className={style.topOffset}>
          <li>
            С&nbsp;
            <a href="https://www.tiger.trade/ru/terminal" className={style.link}>
              платформой Tiger.com для Windows
            </a>
            &nbsp; можно из окна одного терминала торговать акциями, фьючерсами, криптовалютами,
            опционами и инструментами рынка Forex;
          </li>
          <li>
            В&nbsp;
            <a href={TERMINAL_MAC_OS_LINKS.ru} className={style.link}>
              macOS-терминале
            </a>
            &nbsp; возможно торговать криптовалютами.
          </li>
        </ul>
      </>
    ),
  },
];

const DROPDOWN_LIST_DATA_UA = (t: TFunction) => [
  {
    id: 1,
    title: 'Що таке tiger.com?',
    text: (
      <>
        З 2015 року tiger.com займається розробкою фінтех продуктів для трейдерів будь-якого рівня:
        від досвідчених професіоналів до звичайних користувачів. Над нашими продуктами працює
        міжнародна команда ентузіастів у галузі фінтех.
        <ul className={style.topOffset}>
          Наші продукти:
          <li>
            <a href="https://www.tiger.trade/ua/terminal" className={style.link}>
              Tiger.com for Windows
            </a>
            &nbsp; — комп'ютерна платформа, яка дозволяє вести торгівлю на фінансових ринках та
            криптовалютних біржах.
          </li>
          <li>
            <a href={TERMINAL_MAC_OS_LINKS.ru} className={style.link}>
              Tiger.com macOS
            </a>{' '}
            — торговий додаток для macOS
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    title: 'Що таке торгова платформа?',
    text: (
      <>
        Торгова платформа Tiger.com – це гнучке рішення для торгівлі на фондових, ф’ючерсних,
        криптовалютних ринках та Форекс. Платформа має широкий арсенал інструментів, що здатні
        задовольнити як новачків, так і професіональних трейдерів. Платформа Tiger.com пропонує:
        <ul className={style.topOffset}>
          <li>торгівлю акціями, ф’ючерсами, опціонами, криптовалютою та інструментами Форекс</li>
          <li>демо-торгівлю на живих та історичних даних</li>
          <li>вбудовану систему керування ризиками</li>
          <li>
            багатофункціональні діаграми, включаючи кластери, Renko, об’ємні бари та різноманітні
            індикатори
          </li>
          <li>стакан цін з широким функціоналом для активної торгівлі.</li>
        </ul>
        <div>Завдяки платформі можна підключатися до:</div>
        <ul className={style.topOffset}>
          <li>
            різних криптовалютних та фондових бірж, таких як NYSE, NASDAQ, MOEX, SPBEX, Binance, OKX
            та ByBit,
          </li>
          <li>
            торгових терміналів: SMARTcom, QUIK, MetaTrader 5, Rithmic, TRANSAQ та GAIN Capital
            (OEC).
          </li>
        </ul>
        Наразі платформа Tiger.com доступна для&nbsp;
        <a href="https://www.tiger.trade/ua/terminal" target="_blank" className={style.link}>
          Microsoft Windows
        </a>
        &nbsp;та&nbsp;
        <a href={TERMINAL_MAC_OS_LINKS.en} target="_blank" className={style.link}>
          macOS
        </a>
        .
      </>
    ),
  },
  {
    id: 4,
    title: 'Продукти tiger.com безоплатні?',
    text: (
      <>
        <a href="http://tiger.trade/ua/terminal" className={style.link}>
          Торгову платформу Tiger.com
        </a>
        &nbsp; можна завантажити та використовувати безоплатно з необмеженою криптоліцензією. Ви
        зможете торгувати криптовалютою на провідних міжнародних криптобіржах абсолютно безкоштовно.
        <div className={style.topOffset}>
          Якщо ж вас цікавлять інші види активів, такі як акції, ф’ючерси, опціони та інструменти
          Форекс, доведеться придбати повну ліцензію. На щастя, Tiger.com є однією з найдоступніших
          професійних торгових платформ на ринку. Дізнайтеся більше про&nbsp;
          <a href="https://www.tiger.trade/ua/terminal/prices" className={style.link}>
            наші ціни
          </a>
          .
        </div>
      </>
    ),
  },
  {
    id: 5,
    title: 'Як завантажити продукти tiger.com?',
    text: (
      <>
        <ul>
          <li>
            Щоб завантажити торгову платформу <mark>Tiger.com</mark> для Windows,&nbsp;
            <a href="https://www.tiger.trade/ua/terminal/download" className={style.linkSecondary}>
              перейдіть по посиланню
            </a>
            .
          </li>
          <li>
            Щоб завантажити термінал <mark>Tiger.com для macOS</mark>,&nbsp;
            <a href={TERMINAL_MAC_OS_LINKS.ua} target="_blank" className={style.linkSecondary}>
              перейдіть по посиланню
            </a>
            .
          </li>
        </ul>
        <div className={style.topOffset}>
          Ми не рекомендуємо завантажувати та встановлювати продукти Tiger.com зі сторонніх
          веб-сайтів, бо не можемо гарантувати, що вони є безпечними.
        </div>
      </>
    ),
  },
  {
    id: 6,
    title: 'З якими активами можна працювати через tiger.com?',
    text: (
      <ul>
        <li>
          <a href="https://www.tiger.trade/ua/terminal" className={style.link}>
            Платформа Tiger.com для Windows
          </a>
          &nbsp; надає трейдерам доступ до багатьох типів активів у єдиному рішенні. Ви можете
          купляти та продавати акції, ф’ючерси, опціони, криптовалюти, або торгувати на ринках
          Форекс.
        </li>
        <li>
          <a href={TERMINAL_MAC_OS_LINKS.ua} className={style.link}>
            Tiger.com для macOS
          </a>
          &nbsp; надає користувачам можливість торгувати криптовалютами на популярних біржах.
        </li>
      </ul>
    ),
  },
];

const DROPDOWN_LIST_DATA_ES = (t: TFunction) => [
  {
    id: 1,
    title: '¿Qué es tiger.com?',
    text: (
      <>
        Desde 2015, tiger.com desarrolla productos fintech para traders de todo tipo: desde
        profesionales muy experimentados hasta usuarios casuales. Nuestras soluciones son
        desarrolladas por un equipo internacional de entusiastas fintech.
        <ul className={style.topOffset}>
          Nuestros productos son:
          <li>
            <a href="https://www.tiger.trade/en/terminal" className={style.link}>
              Tiger.com para Windows
            </a>
            &nbsp; — una plataforma de escritorio que permite operar en mercados financieros y de
            criptomonedas.
          </li>
          <li>
            <a href={TERMINAL_MAC_OS_LINKS.ru} className={style.link}>
              Tiger.com macOS
            </a>{' '}
            — Nuestra aplicación de trading para macOS
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 2,
    title: '¿Qué es la plataforma de trading?',
    text: (
      <>
        La plataforma de trading Tiger.com es un área de trabajo de escritorio personalizable para
        operar con acciones, futuros, criptomonedas y activos de divisas. Ofrece una exhaustiva gama
        de herramientas para satisfacer las necesidades de principiantes, traders avanzados y
        profesionales por igual. Características de la plataforma Tiger.com:
        <ul className={style.topOffset}>
          <li>trading de acciones, futuros, opciones, cripto y activos de divisas</li>
          <li>demos de trading con datos históricos y en tiempo real</li>
          <li>sistema de gestión de riesgos</li>
          <li>
            gráficos multifunción, incluyendo clústeres, Renko y barras de volumen, con varios
            indicadores
          </li>
          <li>libro de órdenes (DOM) con varias funciones para el trading activo.</li>
        </ul>
        <div>Al usar la plataforma, los usuarios pueden conectarse a:</div>
        <ul className={style.topOffset}>
          <li>
            diferentes bolsas de valores y criptomonedas como NYSE, NASDAQ, MOEX, SPBEX, Binance,
            OKX, y ByBit
          </li>
          <li>
            terminales de trading: SMARTcom, QUIK, MetaTrader 5, Rithmic, TRANSAQ, y GAIN Capital
            (OEC).
          </li>
        </ul>
        Tiger.com está disponible para&nbsp;
        <a href="https://www.tiger.trade/en/terminal" target="_blank" className={style.link}>
          Microsoft Windows
        </a>
        &nbsp;y&nbsp;
        <a href={TERMINAL_MAC_OS_LINKS.en} target="_blank" className={style.link}>
          macOS
        </a>
        .
      </>
    ),
  },
  {
    id: 4,
    title: '¿Los productos tiger.com son gratis?',
    text: (
      <>
        -{' '}
        <a href="http://tiger.trade/en/terminal" className={style.link}>
          La plataforma de trading Tiger.com
        </a>
        &nbsp; es gratuita y viene con una licencia cripto ilimitada y gratuita. Puede operar con
        activos cripto en las principales plataformas de criptomonedas del mundo de forma gratuita.
        <div className={style.topOffset}>
          Si está interesado en otros tipos de activos, como acciones, futuros, opciones y mercado
          de divisas, tendrá que comprar la licencia completa. Tiger.com es una de las plataformas
          de trading profesional más asequibles del mercado. Aprenda más sobre&nbsp;
          <a href="https://www.tiger.trade/en/terminal/prices" className={style.link}>
            nuestros precios
          </a>
          .
        </div>
      </>
    ),
  },
  {
    id: 5,
    title: '¿Cómo descargar los productos tiger.com?',
    text: (
      <>
        <ul>
          <li>
            Para descargar la plataforma de trading <mark>Tiger.com</mark> para Windows, acceda
            a&nbsp;
            <a href="https://www.tiger.trade/terminal/download" className={style.linkSecondary}>
              este&nbsp;enlace
            </a>
            .
          </li>
          <li>
            Para descargar <mark>Tiger.com para macOS</mark>, acceda a&nbsp;
            <a href={TERMINAL_MAC_OS_LINKS.en} target="_blank" className={style.linkSecondary}>
              este enlace
            </a>
            .
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 6,
    title: '¿Qué activos puede comerciar en tiger.com?',
    text: (
      <ul>
        <li>
          - La plataforma{' '}
          <a href="https://www.tiger.trade/terminal" className={style.link}>
            Tiger.com para Windows
          </a>
          &nbsp; permite que los traders accedan a varios activos desde un único lugar. Pueden
          comprar y vender acciones, futuros, opciones, criptomonedas y operar en mercados de
          divisas.
        </li>
        <li>
          -{' '}
          <a href={TERMINAL_MAC_OS_LINKS.en} className={style.link}>
            Tiger.com para macOS
          </a>
          &nbsp; permite operar con criptomonedas en plataformas populares.
        </li>
      </ul>
    ),
  },
];

const LOCALE_TO_LIST = {
  en: DROPDOWN_LIST_DATA_EN,
  ua: DROPDOWN_LIST_DATA_UA,
  ru: DROPDOWN_LIST_DATA_RU,
  es: DROPDOWN_LIST_DATA_ES,
};

const FAQ = () => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  return (
    <div className={style.main}>
      <div className={style.faq}>
        <div className={style.mainContainer}>
          <div className={style.title}>{t('faq_h1')}</div>
          <div className={style.wrap}>
            {LOCALE_TO_LIST[locale](t).map(({ id, text, title }) => (
              <FaqSection key={id} text={text} title={title} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

type FaqSectionProps = {
  title: string;
  text: string;
};

const FaqSection: FC<FaqSectionProps> = ({ text, title }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleDropdown = (): void => {
    setIsOpen((value) => !value);
  };

  return (
    <div className={clsx(style.el, isOpen && style.openedEl)}>
      <div className={style.elTitle} onClick={toggleDropdown}>
        {title}
        <div className={style.arrow} />
      </div>
      <div className={style.in}>
        <div className={style.ind}>{text}</div>
      </div>
    </div>
  );
};

export default FAQ;
